<ng-container *ngIf="row && item">
    <div class="action-buttons" [matMenuTriggerFor]="beforeMenu" [ngClass]="{
            'approve': row[item.field] == ACTION_EVENT.APPROVED,
            'pending': row[item.field] == ACTION_EVENT.PENDING,
            'paid': row[item.field] == ACTION_EVENT.PAID || row[item.field] == ACTION_EVENT.COMPLETE,
            'rejected': row[item.field] == ACTION_EVENT.REJECTED || row[item.field] == ACTION_EVENT.CANCELED,
            'closed': row[item.field] == ACTION_EVENT.CLOSED || row[item.field] == ACTION_EVENT.RESCHEDULE,
            'open': row[item.field] == ACTION_EVENT.OPEN,
            'inprogress': row[item.field] == ACTION_EVENT.INPROGRESS,
            'text-center': row.user_id == userDetail.user_id || userDetail.can_approve === false,
            'disable-btn': (row[item.field] === ACTION_EVENT.APPROVED || row[item.field] === ACTION_EVENT.PAID || row[item.field] === ACTION_EVENT.REJECTED || row[item.field] === ACTION_EVENT.CLOSED || row[item.field] === ACTION_EVENT.CANCELED || row[item.field] === ACTION_EVENT.COMPLETE) || (row.user_id === userDetail.user_id) || (userDetail.can_approve === false && userDetail.can_support === false)
        }">
        <div class="flex-grow-1">
            {{
                row[item.field] == ACTION_EVENT.PENDING
                ? ACTION_EVENT.PENDING
                : row[item.field] == ACTION_EVENT.APPROVED
                ? ACTION_EVENT.APPROVED
                : row[item.field] == ACTION_EVENT.PAID
                ? ACTION_EVENT.PAID
                : row[item.field] == ACTION_EVENT.REJECTED
                ? ACTION_EVENT.REJECTED
                : row[item.field] == ACTION_EVENT.CLOSED
                ? ACTION_EVENT.CLOSED
                : row[item.field] == ACTION_EVENT.OPEN
                ? ACTION_EVENT.OPEN
                : row[item.field] == ACTION_EVENT.CANCELED
                ? ACTION_EVENT.CANCELED
                : row[item.field] == ACTION_EVENT.COMPLETE
                ? ACTION_EVENT.COMPLETE
                : row[item.field] == ACTION_EVENT.RESCHEDULE
                ? ACTION_EVENT.RESCHEDULE
                : ACTION_EVENT.INPROGRESS
                }}
        </div>
        <ng-container *ngIf="row.user_id !== userDetail.user_id && (userDetail.can_approve === true || userDetail.can_support == true)">
            <ng-container
                *ngIf="row[item.field] !== ACTION_EVENT.APPROVED && row[item.field] !== ACTION_EVENT.PAID && row[item.field] !== ACTION_EVENT.REJECTED && row[item.field] !== ACTION_EVENT.CLOSED && row[item.field] !== ACTION_EVENT.CANCELED && row[item.field] !== ACTION_EVENT.COMPLETE">
                <div class="text-end my-auto">
                    <img src="/assets/angle-down-solid.svg" alt="arrow-down"
                        style="color: #444444; height: 12px; width: 12px" />
                </div>
            </ng-container>
        </ng-container>
    </div>
    <mat-menu #beforeMenu="matMenu" xPosition="before">
        <div class="mx-3">
            <button class="btn-disable-menu" mat-menu-item>CHANGE STATUS TO:</button>
            <ng-container *ngIf="item.btnTypes">
                <button *ngFor="let actBtn of item.btnTypes" class="btn-menu" mat-menu-item
                    (click)="click(i, item.type, actBtn)">
                    {{actBtn ? actBtn : ''}}
                </button>
            </ng-container>
        </div>
    </mat-menu>
</ng-container>